import React from 'react';
import 'style.css';
import 'css/care_window.css';
import 'css/responsive.css';
import 'css/perfect-scrollbar.css';
import 'css/custom.css';
import 'css/color_2.css';
import 'css/bootstrap-select.css';

import carewindow_blue from 'images/carewindow_blue.png';

function WifiReady() {
  return (
    <div className="full_container">
      <div className="container">
        <div className="center verticle_center full_height">
          <div className="login_section" style={{ maxWidth: "640px" }}>
            <div className="logo_login">
              <div className="center">
                <img className="login-carewindow" width="500" src={carewindow_blue} alt="CareWindow" />
              </div>
            </div>

            <div className="login_form" style={{ textAlign: "center" }}>
              <h2 style={{ marginTop: 10, fontWeight: 700 }}>
                Thanks for finishing the set up!
              </h2>
              <h4 style={{ marginTop: 40, fontSize: 16 }}>
                Your internet is ready to go.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WifiReady;
